export function isFoneCel(fone: string): boolean {
  const FONE: string = `${fone}`.replace(/[^\d]+/g, '');
  return !!(FONE && [9, 11, 13, 14].includes(FONE.length));
}
